import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { RangeField, RangeLabel } from '../styles'

function RangeInput({ value, onChange }) {
  const { t } = useTranslation()
  const v = value || {}
  return (
    <div className="d-flex gap-3 align-items-center mt-2">
      <div>
        <RangeLabel>{t('rangeQuestion.from')}</RangeLabel>
        <RangeField
          type="number"
          value={v.start ?? ''}
          onChange={(e) => onChange({ ...v, start: e.target.value })}
        />
      </div>
      <div>
        <RangeLabel>{t('rangeQuestion.to')}</RangeLabel>
        <RangeField
          type="number"
          value={v.end ?? ''}
          onChange={(e) => onChange({ ...v, end: e.target.value })}
        />
      </div>
    </div>
  )
}

RangeInput.propTypes = {
  value: PropTypes.shape({
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onChange: PropTypes.func.isRequired,
}

export default RangeInput
